import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchHttpParams } from '@heda/core-util';
import { MessageConfig, MessageConfigQueryParams } from 'app/integration/message-config/services/message-config';

@Injectable({ providedIn: 'root' })
export class MessageConfigService {
  protected baseUrl = `${environment.estnhsApi}/integration/message-config`;

  constructor(private http: HttpClient) {}

  public query(params: MessageConfigQueryParams): Observable<MessageConfig[]> {
    const p: any = Object.assign({}, params);
    return this.http
      .get(`${this.baseUrl}`, { params: SearchHttpParams.build(p) })
      .pipe(map((resp) => resp as MessageConfig[]));
  }

  public save(config: MessageConfig): Observable<any> {
    return this.http.put(this.baseUrl + '/' + config.id, config);
  }

  public getDocumentConfig(): Observable<MessageConfig> {
    return this.query({ serviceCode: 'RCMR_IN000006UV01' }).pipe(map((configs) => configs[0]));
  }
}
